import { Link, useLocation } from "react-router-dom";
import ArenaSvg from "../../assets/svg/navbar/ArenaSvg";
import FillCardSvg from "../../assets/svg/navbar/FillCardSvg";
import HomeSvg from "../../assets/svg/navbar/HomeSvg";
import MenuSvg from "../../assets/svg/navbar/MenuSvg";
import "./Navbar.scss";
import ReactDOM from "react-dom";

function Navbar() {
    const location = useLocation();

    return ReactDOM.createPortal(
        <div className="nav-wrapper">
            <div className="nav-container">
                <Link to={"/"} className={"nav-block " + (location.pathname === "/" ? "active" : "")}>
                    <HomeSvg />
                    <span className="nav-description">Главная</span>
                </Link>

                <Link to={"/menu"} className={"nav-block " + (location.pathname.startsWith("/menu") ? "active" : "")}>
                    <MenuSvg />
                    <span className="nav-description">Меню</span>
                </Link>

                <Link to={"/card"} className={"nav-block " + (location.pathname.startsWith("/card") ? "active" : "")}>
                    <FillCardSvg />
                    <span className="nav-description">Карта</span>
                </Link>

                <Link to={"/arena"} className={"nav-block " + (location.pathname.startsWith("/arena") ? "active" : "")}>
                    <ArenaSvg />
                    <span className="nav-description">Арена</span>
                </Link>
            </div>
        </div>,
        document.getElementById("navbar-root")
    );
};

export default Navbar;